/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import LocalDate from '../../../domain/type/Date'
import SessionAction from '../../../action/session'
import HotelOptionsStore from '../../../store/options/HotelOptionsStore'
import MonthlySalesSearchStore from '../../../store/monthly_sales/MonthlySalesSearchStore'
import MonthlySalesListView from '../../../view/pages/report/monthly_sales/ListView'
import DailyClosingHeadsStore from '../../../store/monthly_sales/DailyClosingHeadsStore'
import MonthlyReportAction from '../../../action/monthly_report'
import ReportCheckInAction from '../../../action/monthly_report/check_in'

class ListContainer extends Component {
  static getStores() {
    return [HotelOptionsStore, MonthlySalesSearchStore, DailyClosingHeadsStore]
  }

  static calculateState(prevState, props) {
    return {
      option_hotels: HotelOptionsStore.getState(),
      search: MonthlySalesSearchStore.getState(),
      heads: DailyClosingHeadsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    await SessionAction.fetchUserHotels()

    const date = this.state.match.params.date
    const target_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()
    const hotel_id = this.state.match.params.hotel_id
    // TODO 宿泊施設が1つのみの場合はデフォルトの検索条件に設定する

    if (hotel_id) {
      // 検索条件の宿泊施設を設定
      const event = { target: { name: 'search_hotel_id', value: hotel_id } }
      await MonthlyReportAction.onEditMonthlySalesSearchCondition(event)
    }

    if (this.state.search.search_hotel_id) {
      MonthlyReportAction.onMonthlySalesRequestSearch(this.state.search, target_date)
    }

    NProgress.done()
  }

  render() {
    return MonthlySalesListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
